export class SaveObjectsTransformAction {

  public readonly objects: Array<any>;

  constructor(objects: Array<any>) {
    this.objects = objects;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/eventLog/actions/SaveObjectsTransformAction.ts